import { render } from "./VButtonDelay.vue?vue&type=template&id=de513186"
import script from "./VButtonDelay.vue?vue&type=script&lang=js"
export * from "./VButtonDelay.vue?vue&type=script&lang=js"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__